module.exports = __webpack_public_path__ + "img/St Vincent and the Grenadines.aa99fd1d.svg";